"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * The names of the string constants you can use as HTML attributes for the <tableau-pulse> web component.
 * @ignore
 */
var PulseAttributes;
(function (PulseAttributes) {
    PulseAttributes["DisableExploreFilter"] = "disable-explore-filter";
})(PulseAttributes = exports.PulseAttributes || (exports.PulseAttributes = {}));
//# sourceMappingURL=PulseInterfaces.js.map